/*!

=========================================================
* Black Dashboard React v1.0.0
=========================================================

* Product Page: /product/black-dashboard-react
* Copyright 2019 SecurePoint 360 ()
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by SecurePoint 360

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertTitle } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { QualysLogo } from 'assets';
import { verifyAccessToken } from 'lib/auth';
import React from 'react';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  FormGroup,
  // Form,
  Input,
  Row,
  Col,
} from 'reactstrap';

import history from '../../history';
import axios from '../../lib/axiosInstance';

class Qualys extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      buttonText: 'Create New Connection',
      password: '',
      api_url: 'https://qualysapi.qg3.apps.qualys.com',
      title: 'PG',
      openModal: false,
      modalTitle: 'Success',
      modalTitleFailure: 'Failed to connect',
      modalDetail:
        'Your Qualys Account  is not connected with SecurePoint 360 App!',
      modalDetailFailure:
        'Authentication Failed! It seems your account detail is incorrect.',
      authentication_response: {},
      portal_version: {},
    };
  }
  setValue(key, value) {
    if (key) {
      this.setState({ [key]: value });
      //console.log('stateObject', value)
    }
  }
  async handleSubmit() {
    await verifyAccessToken();
    let data = {
        title: this.state.title,
        username: this.state.username,
        password: this.state.password,
        api_url: this.state.api_url,
      },
      url = '/qualys/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    if (this.state.uuid) {
      await axios
        .patch(url + this.state.qualys_id + '/', data, {
          headers: headers,
        })
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            let currentData = res.data;
            this.setState({
              api_url: currentData.api_url,
              qualys_id: currentData.id,
              is_authenticated: currentData.is_authenticated,
              // password: currentData.password,
              title: currentData.title,
              // username: currentData.username,
              uuid: currentData.uuid,
              authentication_response: currentData.authentication_response,
              portal_version: currentData.portal_version,
              buttonText: 'Update Connection ',
              openModal: true,
            });
            //console.log('Creation or Update Response', res.data)
          } else if (res.status === 422) {
          } else if (res.status === 401) {
          }
        })
        .catch((err) => {
          let res = err.response;
          if (res.status === 401) {
          } else if (res.status === 200) {
          }
        });
    } else {
      await axios
        .post(url, data, {
          headers: headers,
        })
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            let currentData = res.data;
            this.setState({
              api_url: currentData.api_url,
              qualys_id: currentData.id,
              is_authenticated: currentData.is_authenticated,
              // password: currentData.password,
              title: currentData.title,
              // username: currentData.username,
              uuid: currentData.uuid,
              authentication_response: currentData.authentication_response,
              portal_version: currentData.portal_version,
              buttonText: 'Update Connection ',
              openModal: true,
            });
            //console.log('Creation or Update Response',res.data)
          } else if (res.status === 422) {
          } else if (res.status === 401) {
          }
        })
        .catch((err) => {
          let res = err.response;
          if (res.status === 401) {
          } else if (res.status === 200) {
          }
        });
    }
  }
  componentDidMount() {
    this.fetchQualys();
    localStorage.setItem('last_path', window.location.pathname);
  }
  async fetchQualys() {
    await verifyAccessToken();
    let url = '/qualys/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.count > 0) {
            let currentData = res.data.results[0];
            this.setState({
              api_url: currentData.api_url,
              qualys_id: currentData.id,
              is_authenticated: currentData.is_authenticated,
              // password: currentData.password,
              title: currentData.title,
              // username: currentData.username,
              uuid: currentData.uuid,
              authentication_response: currentData.authentication_response,
              portal_version: currentData.portal_version,
              buttonText: 'Update Connection ',
            });
          }
          //console.log('Qualys Data',res.data)
          this.setValue('openModal', false);
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
          localStorage.removeItem('refresh');
          localStorage.removeItem('access');
          localStorage.removeItem('refreshTokenSetAt');
          localStorage.removeItem('accessTokenSetAt');
          history.push('/login');
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
          localStorage.removeItem('refresh');
          localStorage.removeItem('access');
          localStorage.removeItem('refreshTokenSetAt');
          localStorage.removeItem('accessTokenSetAt');
          history.push('/login');
        } else if (res.status === 200) {
        }
      });
  }
  renderNotification() {
    // const [open, setOpen] = React.useState(true);
    return (
      <>
        <Collapse in={this.state.openModal === true}>
          <Alert
            severity={
              this.state.is_authenticated === true ? 'success' : 'error'
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  this.setState({ openModal: false });
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle>
              {this.state.is_authenticated === true
                ? this.state.modalTitle
                : this.state.modalTitleFailure}
            </AlertTitle>
            {this.state.is_authenticated === true
              ? this.state.modalDetail
              : this.state.modalDetailFailure}
          </Alert>
        </Collapse>
      </>
    );
  }
  render() {
    return (
      <>
        <div className="content">
          <Row>
            <Col md="8">
              <Card>
                <CardHeader>
                  <h5 className="title">Your Qualys Integration</h5>
                </CardHeader>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleSubmit();
                  }}
                >
                  <CardBody>
                    <Row>
                      <Col className="pr-md-1" md="5">
                        <FormGroup>
                          <label>Title</label>
                          <Input
                            placeholder="Title"
                            type="text"
                            required={true}
                            defaultValue={this.state.title}
                            onChange={(element) =>
                              this.setValue('title', element.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col className="px-md-1" md="3">
                        <FormGroup>
                          <label>Username</label>
                          <Input
                            placeholder="Username"
                            autoComplete="off"
                            type="text"
                            required={true}
                            defaultValue={this.state.username}
                            onChange={(element) =>
                              this.setValue('username', element.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="4">
                        <FormGroup>
                          <label htmlFor="exampleInputEmail1">Password</label>
                          <Input
                            placeholder="Password"
                            type="password"
                            autoComplete="off"
                            required={true}
                            onChange={(element) =>
                              this.setValue('password', element.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="12">
                        <FormGroup>
                          <label>API URL</label>
                          <Input
                            placeholder="https://qualysapi.qg3.apps.qualys.com"
                            type="text"
                            required={true}
                            defaultValue={this.state.api_url}
                            onChange={(element) =>
                              this.setValue('api_url', element.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter>
                    <Button className="btn-fill" color="primary" type="submit">
                      {this.state.buttonText}
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </Col>
            <Col md="4">
              <Card className="card-user">
                <CardBody>
                  <CardText />
                  <div className="author">
                    <div className="block block-one" />
                    <div className="block block-two" />
                    <div className="block block-three" />
                    <div className="block block-four" />
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img alt="..." className="avatar" src={QualysLogo} />
                      <h5 className="title"></h5>
                    </a>
                    <p className="description">
                      {this.state.is_authenticated === true
                        ? 'Authenticated'
                        : 'Not Connected to Qualys'}
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {this.renderNotification()}
      </>
    );
  }
}

export default Qualys;
